module.exports = __webpack_public_path__ + "static/media/exerciseIconFooter.c6982a76.svg";